export const formatRut = (value: string): string => {
  const cleaned = value.replace(/[^0-9kK]/g, '');

  if (cleaned.length <= 1) return cleaned;

  const dv = cleaned.slice(-1);
  const numbers = cleaned.slice(0, -1);

  const formatted = numbers.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${formatted}-${dv}`;
};

export const validateRut = (rut: string): boolean => {
  const cleaned = rut.replace(/[^0-9kK]/g, '');

  if (cleaned.length < 2) return false;

  const dv = cleaned.slice(-1).toUpperCase();
  const numbers = cleaned.slice(0, -1);

  if (!/^\d+$/.test(numbers)) return false;

  let sum = 0;
  let multiplier = 2;

  for (let i = numbers.length - 1; i >= 0; i--) {
    sum += parseInt(numbers[i]) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }

  const expectedDv = 11 - (sum % 11);
  let calculatedDv: string;

  if (expectedDv === 11) {
    calculatedDv = '0';
  } else if (expectedDv === 10) {
    calculatedDv = 'K';
  } else {
    calculatedDv = expectedDv.toString();
  }

  return dv === calculatedDv;
};

export const isLikelyRut = (value: string): boolean => {
  const cleaned = value.replace(/[^0-9kK]/g, '');

  if (cleaned.length < 8 || cleaned.length > 9) return false;

  const lastChar = cleaned.slice(-1).toUpperCase();
  return /^[0-9K]$/.test(lastChar);
};

export const normalizeRut = (value: string): string => {
  return value.replace(/[^0-9kK]/g, '').toUpperCase();
};

export type TipoDocumento = 'rut' | 'pasaporte';

// El pasaporte no tiene dígito verificador ni checksum: solo se puede validar
// el formato (5–20 caracteres, letras y números, sin símbolos).
export const isValidPassport = (value: string): boolean => {
  return /^[A-Za-z0-9]{5,20}$/.test(value.trim());
};

// Valida un documento según su tipo. Retorna el mensaje de error, o null si es
// válido o está vacío (la obligatoriedad la maneja el formulario, no esta función).
export const validarDocumento = (value: string, tipo: TipoDocumento): string | null => {
  const v = value.trim();
  if (!v) return null;
  if (tipo === 'rut') {
    return validateRut(v) ? null : 'RUT inválido: verifica el dígito verificador';
  }
  return isValidPassport(v) ? null : 'Pasaporte inválido: 5 a 20 letras o números';
};

// Infiere el tipo de documento a partir de un valor existente (para precargar el
// selector al editar). Vacío o con forma de RUT → 'rut'; cualquier otra cosa → 'pasaporte'.
export const inferirTipoDocumento = (value: string): TipoDocumento => {
  return value.trim() && !isLikelyRut(value) ? 'pasaporte' : 'rut';
};
